import React, { useEffect, useState } from "react";
import { TextField, Autocomplete, Grid, Button, Box, Typography } from "@mui/material";
import { LocalizationProvider, DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg"
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from "dayjs";
import "dayjs/locale/it";
import { useDispatch, useSelector } from "react-redux";
import { selectOperatori } from "../../features/operatori/operatoriSlice";
import { fetchAppicazione, fetchSiccurezza, fetchTrattamenti } from "../../features/produzione-trattamenti/produzione-trattamentiThunk";
import { fetchOperatori } from "../../features/operatori/operatoriThunk";
import { fetchProduzioineModdiapplicazione, fetchProduzioineSiccurezza } from "../../features/produzioniFormData/produzioniFormDataThunk";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale("it");

const TrattamentiForm = ({ option, rows, setRows, activeStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const treatmentOptions = useSelector((state) => state.produzioneTrattamenti.produzionetrattamenti) || [];
    const siccurezzaOptions = useSelector((state) => state.produzioniForm.siccurezza) || [];
    const moddiapplicazioneOptions = useSelector((state) => state.produzioniForm.moddiapplicazione) || [];
    const rawOperatori = useSelector(selectOperatori) || [];

    const operatoriOptions = rawOperatori.filter(op => op.role_id === "OPERATOR");
        useEffect(() => {
        dispatch(fetchOperatori({ role_id: "OPERATOR" }));
    }, [dispatch]);
    
    const { control, setValue, formState: { errors } } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, treatmentType: "", datetime: null, productUsed: "", quantity: "", applicationMethod: "", operator: "", safety: "" },
    //     { id: 2, treatmentType: "", datetime: null, productUsed: "", quantity: "", applicationMethod: "", operator: "", safety: "" },
    // ]);

    useEffect(() => {
        dispatch(fetchTrattamenti());
        dispatch(fetchOperatori());
        dispatch(fetchProduzioineSiccurezza());
        dispatch(fetchProduzioineModdiapplicazione());
    }, [dispatch])

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            { 
                company_id: Number(localStorage.getItem('company_id')) || "", 
                step: activeStep, prod_id: 
                singleProduzioneID, pro_treatment_id: "", 
                tratt_date: null, 
                pro_utilizzato: "", 
                pro_qty: "", 
                mod_di_applicazione: "", 
                operatore_id: "", 
                sicurezza: "" 
            }
        ]);
    };

    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "production_step_treatment"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };

    return (
        <Box className="tranport" sx={{ maxWidth: "100%", padding: 2 }}>
            <h3 className="sectiontitleSmall">Trattamenti</h3>
            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid size={0.5}><Typography>ID</Typography></Grid>
                <Grid size={1.7}><Typography>Tipo di trattamento</Typography></Grid>
                <Grid size={1.9}><Typography>Data e ora trattamento</Typography></Grid>
                <Grid size={1.3}><Typography>Pro. utilizzato</Typography></Grid>
                <Grid size={1.3}><Typography>Q.ta prodotto</Typography></Grid>
                <Grid size={1.72}><Typography>Mod. di applicazione</Typography></Grid>
                <Grid size={1.84}><Typography>Operatore responsabile</Typography></Grid>
                <Grid size={1.6}><Typography>Int. di sicurezza</Typography></Grid>
            </Grid>
            {rows?.map((row, index) => (
                <Grid container spacing={1} key={row.id || index} sx={{ marginBottom: 1 }}>
                    <Grid size={0.5}>
                        <TextField label="ID" size="small" value={row.id || index} disabled />
                    </Grid>
                    <Grid size={1.7}>
                        <Controller
                            name={`treatmentType-${index}`}
                            control={control}
                            render={({ field }) => (
                                <Autocomplete
                                    {...field}
                                    options={treatmentOptions}
                                    getOptionLabel={(option) => option.tipo_di_trattamento || ""}
                                    value={treatmentOptions.find((option) => option.id == row.pro_treatment_id) || null}
                                    onChange={(event, value) => {
                                        field.onChange(value);
                                        handleInputChange(index, "pro_treatment_id", value.id);
                                    }}
                                    renderInput={(params) => <TextField className="customTextBox autoCompleteTextBox" {...params} label="Tipo di trattamento" fullWidth />}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={1.9}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                            <Controller
                                name={`datetime-${index}`}
                                control={control}
                                render={({ field }) => (
                                    <DateTimePicker
                                    className='datePickerField'
                                    label="Data e ora trattamento"
                                    value={row?.tratt_date ? dayjs(row.tratt_date) : null}
                                    onChange={(newValue) => {
                                      const formattedDateTime = dayjs(newValue).format("YYYY-MM-DD HH:mm");
                                      field.onChange(formattedDateTime);
                                      handleInputChange(index, "tratt_date", formattedDateTime);
                                    }}
                                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={1.3}>
                        <TextField defaultValue="" className="customTextBox" label="Pro. utilizzato" size="small" value={row.pro_utilizzato || ""} onChange={(e) => handleInputChange(index, "pro_utilizzato", e.target.value)} />
                    </Grid>
                    <Grid size={1.3}>
                        <TextField defaultValue="" lassName="customTextBox" label="Q.ta prodotto" size="small" value={row.pro_qty || ""} onChange={(e) => handleInputChange(index, "pro_qty", e.target.value)} />
                    </Grid>
                    <Grid size={1.72}>
                        <Controller
                            name={`applicationMethod-${index}`}
                            control={control}
                            render={({ field }) => (
                                <Autocomplete
                                    {...field}
                                    options={moddiapplicazioneOptions}
                                    value={row.mod_di_applicazione || ""}
                                    onChange={(event, value) => {
                                        field.onChange(value);
                                        handleInputChange(index, "mod_di_applicazione", value);
                                    }}
                                    renderInput={(params) => <TextField
                                        className="customTextBox autoCompleteTextBox"
                                        {...params} label="Mod. di applicazione" fullWidth />}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={1.84}>
                        <Controller
                            name={`operator-${index}`}
                            control={control}
                            render={({ field }) => (
                                <Autocomplete
                                    {...field}
                                    options={operatoriOptions}
                                    getOptionLabel={(option) => option.name}
                                    value={operatoriOptions.find((option) => option.id == row.operatore_id) || null}
                                    onChange={(event, value) => {
                                        field.onChange(value);
                                        handleInputChange(index, "operatore_id", value.id);
                                    }}
                                    renderInput={(params) => <TextField className="customTextBox autoCompleteTextBox" {...params} label="Operatore responsabile" fullWidth />}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={1.6}>
                        <Controller
                            name={`safety-${index}`}
                            control={control}
                            render={({ field }) => (
                                <Autocomplete
                                    {...field}
                                    options={siccurezzaOptions}
                                    value={row.sicurezza || ""}
                                    onChange={(event, value) => {
                                        field.onChange(value);
                                        handleInputChange(index, "sicurezza", value);
                                    }}
                                    renderInput={(params) => <TextField {...params} className="customTextBox autoCompleteTextBox" label="Int. di sicurezza" fullWidth />}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={0.1}>
                        <MenuWithPDF options={option} handleDelete={() => handleDelete(index)} id={row.id} />
                    </Grid>
                </Grid>
            ))}
            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon /> aggiungi trattamento
            </Button>
        </Box>
    );
};

export default TrattamentiForm;
